import * as Sentry from '@sentry/react';
import packageJson from '../../../package.json';

export const SENTRY_RELEASE_VERSION = packageJson.version;

export function initAppErrorLogger(): void {
    if (import.meta.env.DEV) return;
    Sentry.init({
        dsn: 'https://35c76b3c2ca21292a34c370f06720fbe@o4508448595247104.ingest.de.sentry.io/4508452443390032',
        release: SENTRY_RELEASE_VERSION,
        environment: window.location.hostname,
        maxBreadcrumbs: 50,
        sendDefaultPii: true,
        integrations: [
            Sentry.captureConsoleIntegration({levels: ['warn', 'error']}),
            Sentry.httpClientIntegration(),
            Sentry.browserSessionIntegration(),
            Sentry.browserApiErrorsIntegration({
                setTimeout: true,
                setInterval: true,
                requestAnimationFrame: true,
                XMLHttpRequest: true,
                eventTarget: true,
            }),
        ],
    });
}
